// utils/hotjarAuth.ts
// export const getAccessToken = async (): Promise<string | null> => {
//   try {
//     const response = await fetch("https://auth.hotjar.com/oauth/token", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: new URLSearchParams({
//         client_id: "5478760",
//         client_secret: "nVgLYlvmO//hjEB47AsoagJW",
//         grant_type: "client_credentials",
//       }),
//     });

//     const data = await response.json();

//     if (data.access_token) {
//       console.log("Access Token Fetched:", data.access_token);
//       localStorage.setItem("hotjar_access_token", data.access_token);
//       localStorage.setItem(
//         "hotjar_token_expiry",
//         (Date.now() + data.expires_in * 1000).toString()
//       );
//       return data.access_token;
//     }

//     return null;
//   } catch (error) {
//     console.error("Error fetching access token:", error);
//     return null;
//   }
// };

export const getAccessToken = async (): Promise<string | null> => {
  try {
    const response = await fetch("https://api.hotjar.io/v1/oauth/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        client_id: "5478760",
        client_secret: "nVgLYlvmO//hjEB47AsoagJW",
        grant_type: "client_credentials",
      }),
    });

    if (!response.ok) {
      const errorText = await response.text(); // Read response error message
      console.error("Hotjar Auth Error:", errorText);
      return null;
    }

    const data = await response.json();
    console.log("Access Token:", data.access_token);

    localStorage.setItem("hotjar_access_token", data.access_token);
    localStorage.setItem(
      "hotjar_token_expiry",
      (Date.now() + data.expires_in * 1000).toString()
    );

    return data.access_token;
  } catch (error) {
    console.error("Error fetching access token:", error);
    return null;
  }
};

export const getValidAccessToken = async (): Promise<string | null> => {
  const token = localStorage.getItem("hotjar_access_token");
  const expiry = localStorage.getItem("hotjar_token_expiry");

  if (token && expiry && Date.now() < Number(expiry)) {
    return token; // Return cached token if it's still valid
  }

  return await getAccessToken(); // Fetch a new token if expired
};
